<template>
  <div class="d-flex w-100 no-item-container">
    <div class="m-auto">
      <div
        class="d-flex justify-content-center no-img-table-render"
        :style="customCss"
      >
        <img
          class="h-100"
          :src="NoItemImg"
          alt=""
          draggable="false"
        >
      </div>
      <div class="mt-1 empty-color text-center">
        {{ textNoImg }}
      </div>
    </div>
  </div>
</template>

<script>
import NoItemImg from '@/assets/images/artwork/no-item2.png'

import { computed } from '@vue/composition-api'

export default {
  props: {
    textNoImg: String,
    height: Number,
  },
  setup(props) {
    const customCss = computed(() => ({
      height: props.height ? `${props.height}px` : '300px',
    }))

    return {
      NoItemImg,
      customCss,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/override-styles/card-no-item.css';
</style>
